import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Injectable, Input, ComponentFactoryResolver, Directive, ViewContainerRef, NgModule } from '@angular/core';
import { MARKS, BLOCKS, INLINES } from '@contentful/rich-text-types';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function DefaultMarkRendererComponent_b_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "b");
    ɵngcc0.ɵɵelementContainer(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", ctx_r0.node);
} }
function DefaultMarkRendererComponent_code_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "code");
    ɵngcc0.ɵɵelementContainer(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", ctx_r1.node);
} }
function DefaultMarkRendererComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵelementContainer(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", ctx_r2.node);
} }
function DefaultMarkRendererComponent_u_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "u");
    ɵngcc0.ɵɵelementContainer(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", ctx_r3.node);
} }
function DefaultNodeRendererComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r0.node.content);
} }
function DefaultNodeRendererComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r1.node.content);
} }
function DefaultNodeRendererComponent_h1_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r2.node.content);
} }
function DefaultNodeRendererComponent_h2_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r3.node.content);
} }
function DefaultNodeRendererComponent_h3_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r4.node.content);
} }
function DefaultNodeRendererComponent_h4_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r5.node.content);
} }
function DefaultNodeRendererComponent_h5_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h5");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r6.node.content);
} }
function DefaultNodeRendererComponent_h6_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h6");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r7.node.content);
} }
function DefaultNodeRendererComponent_hr_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hr");
} }
function DefaultNodeRendererComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r9.node.content);
} }
function DefaultNodeRendererComponent_ol_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ol");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r10.node.content);
} }
function DefaultNodeRendererComponent_p_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r11.node.content);
} }
function DefaultNodeRendererComponent_blockquote_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "blockquote");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r12.node.content);
} }
function DefaultNodeRendererComponent_ul_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r13.node.content);
} }
function DefaultNodeRendererComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("type: ", ctx_r14.node.nodeType, " id: ", ctx_r14.node.data.target.sys.id, "");
} }
function DefaultNodeRendererComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("type: ", ctx_r15.node.nodeType, " id: ", ctx_r15.node.data.target.sys.id, "");
} }
function DefaultNodeRendererComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("type: ", ctx_r16.node.nodeType, " id: ", ctx_r16.node.data.target.sys.id, "");
} }
function DefaultNodeRendererComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵelement(1, "ngx-contentful-rich-text", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r17.node.data.uri, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nodes", ctx_r17.node.content);
} }
function NgxContentfulRichTextComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 4);
} if (rf & 2) {
    const node_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("node", node_r2);
} }
function NgxContentfulRichTextComponent_ng_container_0_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 5);
} if (rf & 2) {
    const node_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("node", node_r2);
} }
function NgxContentfulRichTextComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxContentfulRichTextComponent_ng_container_0_ng_container_1_ng_container_1_Template, 1, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, NgxContentfulRichTextComponent_ng_container_0_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const node_r2 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", node_r2.nodeType !== "text")("ngIfElse", _r4);
} }
function NgxContentfulRichTextComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxContentfulRichTextComponent_ng_container_0_ng_container_1_Template, 4, 2, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.nodes);
} }
class MarkRenderer {
}
MarkRenderer.ɵfac = function MarkRenderer_Factory(t) { return new (t || MarkRenderer)(); };
MarkRenderer.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MarkRenderer });


const TEXT = `<ng-container ngxMarkRendererHost [node]="node"></ng-container>`;
class DefaultMarkRendererComponent extends MarkRenderer {
    constructor() {
        super(...arguments);
        this.MARKS = MARKS;
    }
}
DefaultMarkRendererComponent.ɵfac = /*@__PURE__*/ function () { let ɵDefaultMarkRendererComponent_BaseFactory; return function DefaultMarkRendererComponent_Factory(t) { return (ɵDefaultMarkRendererComponent_BaseFactory || (ɵDefaultMarkRendererComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DefaultMarkRendererComponent)))(t || DefaultMarkRendererComponent); }; }();
DefaultMarkRendererComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DefaultMarkRendererComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 5, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], ["ngxMarkRendererHost", "", 3, "node"]], template: function DefaultMarkRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, DefaultMarkRendererComponent_b_1_Template, 2, 1, "b", 1);
        ɵngcc0.ɵɵtemplate(2, DefaultMarkRendererComponent_code_2_Template, 2, 1, "code", 1);
        ɵngcc0.ɵɵtemplate(3, DefaultMarkRendererComponent_i_3_Template, 2, 1, "i", 1);
        ɵngcc0.ɵɵtemplate(4, DefaultMarkRendererComponent_u_4_Template, 2, 1, "u", 1);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.node.marks[ctx.node.markIndex].type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.MARKS.BOLD);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.MARKS.CODE);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.MARKS.ITALIC);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.MARKS.UNDERLINE);
    } }, directives: function () { return [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, MarkRendererHostDirective]; }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultMarkRendererComponent, [{
        type: Component,
        args: [{
                template: `
    <ng-container [ngSwitch]="node.marks[node.markIndex].type">
      <b *ngSwitchCase="MARKS.BOLD">${TEXT}</b>
      <code *ngSwitchCase="MARKS.CODE">${TEXT}</code>
      <i *ngSwitchCase="MARKS.ITALIC">${TEXT}</i>
      <u *ngSwitchCase="MARKS.UNDERLINE">${TEXT}</u>
    </ng-container>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class NodeRenderer {
}
NodeRenderer.ɵfac = function NodeRenderer_Factory(t) { return new (t || NodeRenderer)(); };
NodeRenderer.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NodeRenderer });


const CHILDREN = '<ngx-contentful-rich-text [nodes]="node.content"></ngx-contentful-rich-text>';
const DEFAULT_INLINE = '<span>type: {{ node.nodeType }} id: {{ node.data.target.sys.id }}</span>';
class DefaultNodeRendererComponent extends NodeRenderer {
    constructor() {
        super(...arguments);
        this.BLOCKS = BLOCKS;
        this.INLINES = INLINES;
    }
}
DefaultNodeRendererComponent.ɵfac = /*@__PURE__*/ function () { let ɵDefaultNodeRendererComponent_BaseFactory; return function DefaultNodeRendererComponent_Factory(t) { return (ɵDefaultNodeRendererComponent_BaseFactory || (ɵDefaultNodeRendererComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DefaultNodeRendererComponent)))(t || DefaultNodeRendererComponent); }; }();
DefaultNodeRendererComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DefaultNodeRendererComponent, selectors: [["ng-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 19, vars: 19, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], [3, "href", 4, "ngSwitchCase"], [3, "nodes"], [3, "href"]], template: function DefaultNodeRendererComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, DefaultNodeRendererComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DefaultNodeRendererComponent_div_2_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DefaultNodeRendererComponent_h1_3_Template, 2, 1, "h1", 1);
        ɵngcc0.ɵɵtemplate(4, DefaultNodeRendererComponent_h2_4_Template, 2, 1, "h2", 1);
        ɵngcc0.ɵɵtemplate(5, DefaultNodeRendererComponent_h3_5_Template, 2, 1, "h3", 1);
        ɵngcc0.ɵɵtemplate(6, DefaultNodeRendererComponent_h4_6_Template, 2, 1, "h4", 1);
        ɵngcc0.ɵɵtemplate(7, DefaultNodeRendererComponent_h5_7_Template, 2, 1, "h5", 1);
        ɵngcc0.ɵɵtemplate(8, DefaultNodeRendererComponent_h6_8_Template, 2, 1, "h6", 1);
        ɵngcc0.ɵɵtemplate(9, DefaultNodeRendererComponent_hr_9_Template, 1, 0, "hr", 1);
        ɵngcc0.ɵɵtemplate(10, DefaultNodeRendererComponent_li_10_Template, 2, 1, "li", 1);
        ɵngcc0.ɵɵtemplate(11, DefaultNodeRendererComponent_ol_11_Template, 2, 1, "ol", 1);
        ɵngcc0.ɵɵtemplate(12, DefaultNodeRendererComponent_p_12_Template, 2, 1, "p", 1);
        ɵngcc0.ɵɵtemplate(13, DefaultNodeRendererComponent_blockquote_13_Template, 2, 1, "blockquote", 1);
        ɵngcc0.ɵɵtemplate(14, DefaultNodeRendererComponent_ul_14_Template, 2, 1, "ul", 1);
        ɵngcc0.ɵɵtemplate(15, DefaultNodeRendererComponent_ng_container_15_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(16, DefaultNodeRendererComponent_ng_container_16_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(17, DefaultNodeRendererComponent_ng_container_17_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(18, DefaultNodeRendererComponent_a_18_Template, 2, 2, "a", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.node.nodeType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.DOCUMENT);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.EMBEDDED_ENTRY);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_4);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HEADING_6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.HR);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.LIST_ITEM);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.OL_LIST);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.PARAGRAPH);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.QUOTE);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.BLOCKS.UL_LIST);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.INLINES.ASSET_HYPERLINK);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.INLINES.EMBEDDED_ENTRY);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.INLINES.ENTRY_HYPERLINK);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.INLINES.HYPERLINK);
    } }, directives: function () { return [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, NgxContentfulRichTextComponent]; }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultNodeRendererComponent, [{
        type: Component,
        args: [{
                template: `
    <ng-container [ngSwitch]="node.nodeType">
      <ng-container *ngSwitchCase="BLOCKS.DOCUMENT">${CHILDREN}</ng-container>
      <div *ngSwitchCase="BLOCKS.EMBEDDED_ENTRY">${CHILDREN}</div>
      <h1 *ngSwitchCase="BLOCKS.HEADING_1">${CHILDREN}</h1>
      <h2 *ngSwitchCase="BLOCKS.HEADING_2">${CHILDREN}</h2>
      <h3 *ngSwitchCase="BLOCKS.HEADING_3">${CHILDREN}</h3>
      <h4 *ngSwitchCase="BLOCKS.HEADING_4">${CHILDREN}</h4>
      <h5 *ngSwitchCase="BLOCKS.HEADING_5">${CHILDREN}</h5>
      <h6 *ngSwitchCase="BLOCKS.HEADING_6">${CHILDREN}</h6>
      <hr *ngSwitchCase="BLOCKS.HR" />
      <li *ngSwitchCase="BLOCKS.LIST_ITEM">${CHILDREN}</li>
      <ol *ngSwitchCase="BLOCKS.OL_LIST">
        ${CHILDREN}
      </ol>
      <p *ngSwitchCase="BLOCKS.PARAGRAPH">${CHILDREN}</p>
      <blockquote *ngSwitchCase="BLOCKS.QUOTE">${CHILDREN}</blockquote>
      <ul *ngSwitchCase="BLOCKS.UL_LIST">
        ${CHILDREN}
      </ul>
      <ng-container *ngSwitchCase="INLINES.ASSET_HYPERLINK">
        ${DEFAULT_INLINE}
      </ng-container>
      <ng-container *ngSwitchCase="INLINES.EMBEDDED_ENTRY">
        ${DEFAULT_INLINE}
      </ng-container>
      <ng-container *ngSwitchCase="INLINES.ENTRY_HYPERLINK">
        ${DEFAULT_INLINE}
      </ng-container>
      <a *ngSwitchCase="INLINES.HYPERLINK" [href]="node.data.uri">
        ${CHILDREN}
      </a>
    </ng-container>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class RendererProviderService {
    constructor() {
        this.nodeRenderers = {};
        this.markRenderers = {};
    }
    getMarkRenderer(node) {
        const mark = node.marks[node.markIndex];
        const resolver = this.markRenderers[mark.type];
        let renderer;
        try {
            renderer = resolver(node);
        }
        catch (error) {
            renderer = resolver;
        }
        return renderer || DefaultMarkRendererComponent;
    }
    getNodeRenderer(node) {
        const resolver = this.nodeRenderers[node.nodeType];
        let renderer;
        try {
            renderer = resolver(node);
        }
        catch (error) {
            renderer = resolver;
        }
        return renderer || DefaultNodeRendererComponent;
    }
    setNodeRenderers(customRenderers) {
        this.nodeRenderers = Object.assign(this.nodeRenderers, customRenderers);
    }
    setMarkRenderers(customRenderers) {
        this.markRenderers = Object.assign(this.markRenderers, customRenderers);
    }
}
RendererProviderService.ɵfac = function RendererProviderService_Factory(t) { return new (t || RendererProviderService)(); };
RendererProviderService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RendererProviderService_Factory() { return new RendererProviderService(); }, token: RendererProviderService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RendererProviderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgxContentfulRichTextComponent {
    constructor(rendererProvider) {
        this.rendererProvider = rendererProvider;
    }
    ngOnInit() {
        this.rendererProvider.setNodeRenderers(this.nodeRenderers);
        this.rendererProvider.setMarkRenderers(this.markRenderers);
    }
    ngOnChanges(changes) {
        var _a;
        if ((_a = changes.document) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.nodes = [changes.document.currentValue];
        }
    }
}
NgxContentfulRichTextComponent.ɵfac = function NgxContentfulRichTextComponent_Factory(t) { return new (t || NgxContentfulRichTextComponent)(ɵngcc0.ɵɵdirectiveInject(RendererProviderService)); };
NgxContentfulRichTextComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxContentfulRichTextComponent, selectors: [["ngx-contentful-rich-text"]], inputs: { nodes: "nodes", document: "document", nodeRenderers: "nodeRenderers", markRenderers: "markRenderers" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], ["ngxNodeRendererHost", "", 3, "node", 4, "ngIf", "ngIfElse"], ["textNode", ""], ["ngxNodeRendererHost", "", 3, "node"], ["ngxMarkRendererHost", "", 3, "node"]], template: function NgxContentfulRichTextComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxContentfulRichTextComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.nodes == null ? null : ctx.nodes.length);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, NodeRendererHostDirective, MarkRendererHostDirective]; }, encapsulation: 2, changeDetection: 0 });
NgxContentfulRichTextComponent.ctorParameters = () => [
    { type: RendererProviderService }
];
NgxContentfulRichTextComponent.propDecorators = {
    document: [{ type: Input }],
    nodes: [{ type: Input }],
    nodeRenderers: [{ type: Input }],
    markRenderers: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxContentfulRichTextComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-contentful-rich-text',
                template: `
    <ng-container *ngIf="nodes?.length">
      <ng-container *ngFor="let node of nodes">
        <ng-container
          *ngIf="node.nodeType !== 'text'; else textNode"
          ngxNodeRendererHost
          [node]="node"
        >
        </ng-container>
        <ng-template #textNode>
          <ng-container ngxMarkRendererHost [node]="node"></ng-container>
        </ng-template>
      </ng-container>
    </ng-container>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: RendererProviderService }]; }, { nodes: [{
            type: Input
        }], document: [{
            type: Input
        }], nodeRenderers: [{
            type: Input
        }], markRenderers: [{
            type: Input
        }] }); })();

class TextValueComponent {
}
TextValueComponent.ɵfac = function TextValueComponent_Factory(t) { return new (t || TextValueComponent)(); };
TextValueComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextValueComponent, selectors: [["ng-component"]], inputs: { node: "node" }, decls: 1, vars: 1, template: function TextValueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate(ctx.node.value);
    } }, encapsulation: 2, changeDetection: 0 });
TextValueComponent.propDecorators = {
    node: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextValueComponent, [{
        type: Component,
        args: [{
                template: '{{ node.value }}',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { node: [{
            type: Input
        }] }); })();

class ComponentRendererService {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
    }
    render(viewContainerRef, component, node) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.node = node;
        componentRef.changeDetectorRef.detectChanges();
    }
}
ComponentRendererService.ɵfac = function ComponentRendererService_Factory(t) { return new (t || ComponentRendererService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver)); };
ComponentRendererService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ComponentRendererService_Factory() { return new ComponentRendererService(i0.ɵɵinject(i0.ComponentFactoryResolver)); }, token: ComponentRendererService, providedIn: "root" });
ComponentRendererService.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComponentRendererService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, null); })();

class MarkRendererHostDirective {
    constructor(viewContainerRef, componentRenderer, rendererProvider) {
        this.viewContainerRef = viewContainerRef;
        this.componentRenderer = componentRenderer;
        this.rendererProvider = rendererProvider;
    }
    ngOnInit() {
        let component;
        if (isNaN(this.node.markIndex)) {
            // Create new object because node object might not be extensible
            this.node = Object.assign(Object.assign({}, this.node), { markIndex: 0 });
        }
        else {
            this.node.markIndex += 1;
        }
        if (this.node.marks.length > this.node.markIndex) {
            component = this.rendererProvider.getMarkRenderer(this.node);
        }
        else {
            component = TextValueComponent;
        }
        this.componentRenderer.render(this.viewContainerRef, component, this.node);
    }
}
MarkRendererHostDirective.ɵfac = function MarkRendererHostDirective_Factory(t) { return new (t || MarkRendererHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ComponentRendererService), ɵngcc0.ɵɵdirectiveInject(RendererProviderService)); };
MarkRendererHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MarkRendererHostDirective, selectors: [["", "ngxMarkRendererHost", ""]], inputs: { node: "node" } });
MarkRendererHostDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentRendererService },
    { type: RendererProviderService }
];
MarkRendererHostDirective.propDecorators = {
    node: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkRendererHostDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxMarkRendererHost]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ComponentRendererService }, { type: RendererProviderService }]; }, { node: [{
            type: Input
        }] }); })();

class NodeRendererHostDirective {
    constructor(viewContainerRef, componentRenderer, rendererProvider) {
        this.viewContainerRef = viewContainerRef;
        this.componentRenderer = componentRenderer;
        this.rendererProvider = rendererProvider;
    }
    ngOnInit() {
        const component = this.rendererProvider.getNodeRenderer(this.node);
        this.componentRenderer.render(this.viewContainerRef, component, this.node);
    }
}
NodeRendererHostDirective.ɵfac = function NodeRendererHostDirective_Factory(t) { return new (t || NodeRendererHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ComponentRendererService), ɵngcc0.ɵɵdirectiveInject(RendererProviderService)); };
NodeRendererHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NodeRendererHostDirective, selectors: [["", "ngxNodeRendererHost", ""]], inputs: { node: "node" } });
NodeRendererHostDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentRendererService },
    { type: RendererProviderService }
];
NodeRendererHostDirective.propDecorators = {
    node: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NodeRendererHostDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxNodeRendererHost]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ComponentRendererService }, { type: RendererProviderService }]; }, { node: [{
            type: Input
        }] }); })();

class NgxContentfulRichTextModule {
}
NgxContentfulRichTextModule.ɵfac = function NgxContentfulRichTextModule_Factory(t) { return new (t || NgxContentfulRichTextModule)(); };
NgxContentfulRichTextModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxContentfulRichTextModule });
NgxContentfulRichTextModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxContentfulRichTextModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DefaultMarkRendererComponent,
                    DefaultNodeRendererComponent,
                    MarkRendererHostDirective,
                    NgxContentfulRichTextComponent,
                    NodeRendererHostDirective,
                    TextValueComponent,
                ],
                imports: [CommonModule],
                exports: [MarkRendererHostDirective, NgxContentfulRichTextComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxContentfulRichTextModule, { declarations: function () { return [DefaultMarkRendererComponent, DefaultNodeRendererComponent, MarkRendererHostDirective, NgxContentfulRichTextComponent, NodeRendererHostDirective, TextValueComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MarkRendererHostDirective, NgxContentfulRichTextComponent]; } }); })();

/*
 * Public API Surface of ngx-contentful-rich-text
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CHILDREN, DefaultMarkRendererComponent, DefaultNodeRendererComponent, MarkRenderer, MarkRendererHostDirective, NgxContentfulRichTextComponent, NgxContentfulRichTextModule, NodeRenderer, TEXT, RendererProviderService as ɵa, ComponentRendererService as ɵb, NodeRendererHostDirective as ɵc, TextValueComponent as ɵd };

